export const enrolmentHealthMetadata = {
  NOT_STARTED: { label: 'Not started', color: 'gray', variant: 'outline' },
  PAUSED: { label: 'Paused', color: 'gray', variant: 'outline' },
  WITHDRAWN: { label: 'Withdrawn', color: 'gray', variant: 'outline' },
  DELETED: { label: 'Deleted', color: 'gray', variant: 'outline' },
  COMPLETED: { label: 'Completed', color: 'green', variant: 'solid' },
  ON_TRACK: { label: 'On track', color: 'green', variant: 'solid' },
  SLIPPING: { label: 'Slipping', color: 'orange', variant: 'solid' },
  BEHIND: { label: 'Behind', color: 'red', variant: 'solid' },
} as const;

export const enrolmentHealthFilterOptions = (
  ['ON_TRACK', 'SLIPPING', 'BEHIND', 'NOT_STARTED'] as const
).map((key) => ({
  key: key.toLowerCase(),
  label: enrolmentHealthMetadata[key].label,
}));
